
export class AppVersion {

  number!: string;
  commit!: string;
  buildTime!: Date;

  static current: AppVersion = { number: '57', commit: 'e9c9fab', buildTime: new Date('2026-03-16T07:53:27.538Z') };
}